import { call, fork, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

export function* getUser() {
    const response = yield call(api.getUser);
    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_USER.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_USER.FAILURE,
        message: response.errors[0].messages[0],
    });

    return response;
}

export function* watchGetUser() {
    while (true) {
        yield take(actionTypes.GET_USER.REQUEST);
        yield fork(getUser);
    }
}

export function* authUser(email, password) {
    const response = yield call(api.authUser, email, password);

    if (response.status === 200 && response.data.role === 'user') {
        yield put({
            type: actionTypes.AUTH_USER.FAILURE,
            message: 'You don`t have permissions',
        });

        yield call(api.logoutUser);

        return response;
    }

    if (response.status === 200) {
        yield put({
            type: actionTypes.AUTH_USER.SUCCESS,
            data: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `User ${email} login`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.AUTH_USER.FAILURE,
        message: response.errors ? response.errors[0].messages[0] : 'Something went wrong',
    });
}

export function* watchAuthUser() {
    while (true) {
        const { email, password } = yield take(actionTypes.AUTH_USER.REQUEST);
        yield fork(authUser, email, password);
    }
}

function* logoutUser() {
    const response = yield call(api.logoutUser);
    if (response.status === 200) {
        yield put({
            type: actionTypes.LOGOUT_USER.SUCCESS,
            data: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `User logout`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.LOGOUT_USER.FAILURE,
        message: response.errors[0].messages[0],
    });

    return response;
}

export function* watchLogoutUser() {
    while (true) {
        yield take(actionTypes.LOGOUT_USER.REQUEST);
        yield fork(logoutUser);
    }
}

function* getUserLimitationsList(pagination) {
    const response = yield call(api.getUserLimitationsList, pagination);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_USER_LIMITATIONS_LIST.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_USER_LIMITATIONS_LIST.FAILURE,
        message: response.errors[0].messages[0],
    });

    return response;
}

export function* watchGetUserLimitationsList() {
    while (true) {
        yield take(actionTypes.GET_USER_LIMITATIONS_LIST.REQUEST);
        yield fork(getUserLimitationsList);
    }
}

function* getUserList(pagination) {
    const response = yield call(api.getUserList, pagination);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_USER_LIST.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_USER_LIST.FAILURE,
        message: response.errors[0].messages[0],
    });

    return response;
}

export function* watchGetUserList() {
    while (true) {
        const { pagination } = yield take(actionTypes.GET_USER_LIST.REQUEST);
        yield fork(getUserList, pagination);
    }
}

function* banUserById(user) {
    const response = yield call(api.banUserById, user);

    if (response.status === 200) {
        yield put({
            type: actionTypes.BAN_USER_BY_ID.SUCCESS,
            data: user,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `User ${user._id} ban`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 99999,
        },
    });

    yield put({
        type: actionTypes.BAN_USER_BY_ID.FAILURE,
        message: response.errors[0].messages[0],
    });

    return response;
}

export function* watchBanUserById() {
    while (true) {
        const { user } = yield take(actionTypes.BAN_USER_BY_ID.REQUEST);
        yield fork(banUserById, user);
    }
}

function* unbanUserById(user) {
    const response = yield call(api.unbanUserById, user);

    if (response.status === 200) {
        yield put({
            type: actionTypes.UNBAN_USER_BY_ID.SUCCESS,
            data: user,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `User ${user._id} unban`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 99999,
        },
    });

    yield put({
        type: actionTypes.UNBAN_USER_BY_ID.FAILURE,
        message: response.errors[0].messages[0],
    });

    return response;
}

export function* watchUnbanUserById() {
    while (true) {
        const { user } = yield take(actionTypes.UNBAN_USER_BY_ID.REQUEST);
        yield fork(unbanUserById, user);
    }
}

function* setUserToBlackList(emails, user) {
    const response = yield call(api.setUserToBlackList, emails, user);

    if (response.status === 200) {
        yield put({
            type: actionTypes.SET_USER_TO_BLACK_LIST.SUCCESS,
            emails,
            user,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `${response.data.message}`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 99999,
        },
    });

    yield put({
        type: actionTypes.SET_USER_TO_BLACK_LIST.FAILURE,
        message: response.errors[0].messages[0],
    });

    return response;
}

export function* watchSetUserToBlackList() {
    while (true) {
        const { emails, user } = yield take(actionTypes.SET_USER_TO_BLACK_LIST.REQUEST);
        yield fork(setUserToBlackList, emails, user);
    }
}

function* setUserToWhiteList(emails, user) {
    const response = yield call(api.setUserToWhiteList, emails, user);

    if (response.status === 200) {
        yield put({
            type: actionTypes.SET_USER_TO_WHITE_LIST.SUCCESS,
            emails,
            user,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `${response.data.message}`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 99999,
        },
    });

    yield put({
        type: actionTypes.SET_USER_TO_WHITE_LIST.FAILURE,
        message: response.errors[0].messages[0],
    });

    return response;
}

export function* watchSetUserToWhiteList() {
    while (true) {
        const { emails, user } = yield take(actionTypes.SET_USER_TO_WHITE_LIST.REQUEST);
        yield fork(setUserToWhiteList, emails, user);
    }
}

function* toggleWhiteList(user, whiteActive) {
    const response = yield call(api.toggleWhiteList, user, whiteActive);

    if (response.status === 200) {
        yield put({
            type: actionTypes.TOGGLE_WHITE_LIST.SUCCESS,
            user,
            whiteActive,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 99999,
        },
    });

    yield put({
        type: actionTypes.TOGGLE_WHITE_LIST.FAILURE,
        message: response.errors[0].messages[0],
    });

    return response;
}

export function* watchToggleWhiteList() {
    while (true) {
        const { user, whiteActive } = yield take(actionTypes.TOGGLE_WHITE_LIST.REQUEST);
        yield fork(toggleWhiteList, user, whiteActive);
    }
}

export default [
    watchLogoutUser,
    watchAuthUser,
    watchGetUser,
    watchGetUserList,
    watchBanUserById,
    watchUnbanUserById,
    watchGetUserLimitationsList,
    watchSetUserToBlackList,
    watchSetUserToWhiteList,
    watchToggleWhiteList,
]


// WEBPACK FOOTER //
// ./app/sagas/users/index.js